
import tccf7Create from './tccf7Create.js';
import tccf7Back from './tccf7Back.js';

/**
 * tccf7Confirm クラス
 * - 入力 → 確認 → 完了 のステップ制御
 * - ボタン状態やクラス切り替え
 * - アニメーションやスクロール処理
 */
export default class tccf7Confirm {
  /**
   * @param {Object} args - 初期設定オブジェクト
   */
  constructor( args ) {
    // 基本オブジェクト・要素取得
    this.base             = args.base;
    this.elem             = this.base.elem;
    this.form             = this.base.form;
    this.error            = this.base.error;

    // クラス名定義
    this.class            = args.class;
    this.btnClass         = this.class.btn;
    this.errorClass       = this.class.error;
    this.step             = this.class.step;
    this.none             = this.class.none;

    // JSON 設定
    this.json             = args.json;

    // オプション
    this.animation        = args.option.anime;
    this.scroll           = args.option.scroll;
    
    // 状態管理
    this.status           = args.status.progress;
    this.statusElem       = args.status.statusElem;
    this.sendCheck        = args.status.send.confirm;
    this.honeyCheck       = args.status.send.honey;

    // ID class
    this.elemId           = this.elem.id;
    // ----------------
    this.confirmCloneId   = 'confirm-form-clone_' + this.elemId;
    this.confirmWrapId    = this.json.confirm.confirm_target || 'form-confirm';
    this.confirmWrapClass = this.btnClass.confirmWrap;
    this.confirmBtnClass  = this.btnClass.confirm;
    // ----------------
    this.completeId       = this.json.confirm.complete_target || 'complete_' + this.elemId;
    // ----------------
    this.inputWrapId      = this.json.confirm.input_target || 'form-input';
    // ----------------
    this.cursorId         = 'tccf7-cursor';
    this.submitBtnClass   = this.btnClass.send;
    this.allBtnClass      = this.btnClass.all;
    // ----------------
    this.animationClass   = 'tccf7_loading';
    this.errorClass       = this.errorClass.confirm;
    this.noneClass        = this.animation ? 'tccf7_none_anime' : this.none;
    
    // DOM一時保持
    this.confirmWrap      = null;
    this.inputWrap        = null;
    this.confirmBtn       = null;
    this.confirmBtnWrap   = null;
    this.backBtnWrap      = null;
    this.submitBtn        = null;
    // ----------------
    this.submitBtnValue   = '送信';
    this.completeSuccess  = true;
    this.start            = false;
    this.bound            = null;

    // ヘルパーインスタンス生成
    this.tccf7Create      = new tccf7Create();
    this.tccf7Back        = new tccf7Back(this.elem, this.btnClass);
    
    this.init();
  }

  /**
   * 初期化処理
   */
  init () {
    if(this.confirmWrapId === false){ return; }
    this.check( true );
    this.initBackBtn();
    this.initConfirm();
    this.start = true;
  }

  /**
   * 確認画面の初期（初期非表示）
   */
  initConfirm() {
    if(this.confirmWrap) {
      this.confirmWrap?.classList.add(this.noneClass);
    }
  }

  /**
   * 戻るボタンの初期化（初期非表示）
   */
  initBackBtn() {
    this.tccf7Back.init( (backBtnWrap) => { 
      this.backBtnWrap = backBtnWrap;
      this.backBtnWrap?.classList.add(this.noneClass);
    });
  }

  /**
   * 各要素取得・エラーチェック
   * @param {boolean} mode - 初回かどうか
   */
  check( mode ){
    this.confirmWrap  = document.getElementById(this.confirmWrapId) || null;
    this.inputWrap    = document.getElementById(this.inputWrapId) || null;
    this.errConfirm(mode);
    this.errInput();
    this.setConfirmBtn();
    this.setSubmitBtn();
  }

  /**
   * 外部からのステータス更新
   * @param {Object} status 
   */
  update(status) {
    if(this.confirmWrapId === false){ return; }
    this.status           = status.progress;
    this.statusElem       = status.statusElem;
    this.honeyCheck       = status.send.honey;
    this.check( false );
    this.updateBackBtn();
  }

  /**
   * 戻るボタンの状態更新とクリック設定
   */
  updateBackBtn() {
    this.tccf7Back.update( ( backBtnWrap ) => { 
      this.backBtnWrap = backBtnWrap;
      if( this.status !== 'confirm' ) {
        this.backBtnWrap?.classList.add(this.noneClass);
      }else{
        this.backBtnWrap?.classList.remove(this.noneClass);
      }
    }, ( backBtnWrap ) => {
      this.backBtnWrap = backBtnWrap;
      this.clickBack();
    });
  }

  /**
   * 確認画面に入力内容を複製表示
   */
  setConfirm() {
    this.errInput();
    const cloneInputWrap = this.inputWrap.cloneNode(true);
    cloneInputWrap.setAttribute('id', this.confirmCloneId);
    cloneInputWrap.classList.remove(this.noneClass);
    this.tccf7Create.createConfirmTable(cloneInputWrap, this.confirmWrap, this.noneClass);
  }

  /**
   * 完了画面表示のセットアップ
   * @param {boolean} bool - 確認画面のリダイレクト設定が有効か否か　無効の場合のみ動作
   */
  setComplete(bool) {
    const submitBtn   = this.submitBtnClass;
    const confirmWrap = document.getElementById(this.confirmWrapId);

    if(bool === false){
      if(document.getElementById(this.completeId)) {
        document.getElementById(this.completeId).classList.add(this.noneClass);
      }
      
      const complete    = this.clickComplete.bind(this);
      const enterScroll = this.enter.bind(this);
      this.submitBtn?.addEventListener('click', () => {
        this.submitBtn.value = '送信中';
        enterScroll();
      }, false);
      
      document.addEventListener('wpcf7mailsent', () => {
        this.completeSuccess = true;
        const submit = document.querySelector(submitBtn) || null;
        if(submit) {
          submit.value = '送信完了';
          submit.setAttribute('disabled','');
          confirmWrap.querySelector('.tccf7-submit-err')?.remove();
        }
        complete();
      }, false);
      document.addEventListener('wpcf7mailfailed', () => {
        this.completeSuccess = false;
        complete();
      }, false);
    }

    document.addEventListener( 'wpcf7invalid', function( event ) {
      const submit = document.querySelector(submitBtn) || null;
      confirmWrap.querySelector('.tccf7-submit-err')?.remove();
      
      if(submit) {
        submit.value = '送信失敗';
        submit.setAttribute('disabled','');

        if (confirmWrap) {
          const errorMessage = document.createElement('p');
          errorMessage.classList.add('tccf7-submit-err');
          errorMessage.textContent = '送信は失敗しました。入力に不備がある可能性があります。';
          confirmWrap.appendChild(errorMessage);
        }
      }
    }, false );
  }

  /**
   * 確認ボタン設定
   */
  setConfirmBtn() {
    this.confirmBtnWrap = this.elem.querySelector(this.confirmWrapClass) || null;
    this.confirmBtn     = this.elem.querySelector(this.confirmBtnClass) || null;
    if(this.confirmBtn){
      this.setClick(); 
    }
  }

  /**
   * 送信ボタン設定
   */
  setSubmitBtn() {
    this.submitBtn      = document.querySelector(this.submitBtnClass) || null;
    if(this.submitBtn && 
      this.submitBtn.value !== '送信中' && 
      this.submitBtn.value !== '送信失敗' && 
      this.submitBtn.value !== undefined ){
      this.submitBtnValue = this.submitBtn.value || '送信'; 
    }
    this.submitBtn?.addEventListener('click', () => {
      this.submitBtn.value = '送信中';
    }, false);
  }

  /**
   * 確認ボタンにクリックイベント設定
   */
  setClick() {
    if ( !this.bound ) {
      this.bound = this.clickConfirm.bind(this);
    }
    this.confirmBtn?.removeEventListener('click', this.bound);
    this.confirmBtn?.addEventListener('click', this.bound);
  }

  /**
   * 「戻る」クリック時の処理
   */
  clickBack() {
    if( this.status !== 'input' ) {
      this.tccf7Create.remove(this.confirmCloneId);
      // this.inputClass();
      this.setStepView('input');
      this.status = 'input';
      this.statusElem?.setAttribute('value','input');
      document.body.classList.remove(this.step.stepConfirm);
      document.body.classList.add(this.step.stepInput);
    }
  }

  /**
   * 「確認する」クリック時の処理
   */
  clickConfirm() {
    if( this.status !== 'confirm' ) {
      this.setConfirm();
      // this.confirmClass();
      this.setStepView('confirm');
      this.status = 'confirm';
      this.statusElem?.setAttribute('value','confirm');
      document.body.classList.add(this.step.stepConfirm);
      document.body.classList.remove(this.step.stepInput);
    }
  }

  /**
   * 送信完了後の処理
   */
  clickComplete() {
    this.tccf7Create.remove(this.confirmCloneId);
    if(document.getElementById(this.completeId)) {
      document.getElementById(this.completeId).classList.remove(this.noneClass);
    }else {
      this.tccf7Create.createComplete(this.completeId,this.confirmWrap,this.completeSuccess);
    }
    this.status = 'complete';
    this.statusElem?.setAttribute('value','complete');
    this.inputWrap?.classList.add(this.noneClass);
    document.body.classList.add(this.step.stepComplete);
    document.querySelector(this.allBtnClass)?.classList.add(this.noneClass);

    this.enter();
  }

  /**
   * 表示ステップ切り替え（input / confirm）
   * @param {'input'|'confirm'} step
   */
  setStepView(step) {
    const isInput   = step === 'input';
    const isConfirm = step === 'confirm';

    this.sendCheck = isConfirm;
    this.form.classList.remove(this.errorClass);

    this.confirmWrap?.classList.toggle(this.noneClass, isInput);
    this.inputWrap?.classList.toggle(this.noneClass, isConfirm);
    this.backBtnWrap?.classList.toggle(this.noneClass, isInput);
    this.confirmBtnWrap?.classList.toggle(this.noneClass, isConfirm);
    this.submitBtn?.classList.remove(this.noneClass);

    // input処理
    if (isInput) {
      this.submitBtn?.setAttribute('disabled', 'true');
      if (this.submitBtn) {
        this.submitBtn.value = this.submitBtnValue || '送信';
      }

    // confirm処理
    } else {
      if (this.sendCheck && this.honeyCheck) {
        this.submitBtn?.removeAttribute('disabled');
      } else {
        this.sendCheck = false;
        this.submitBtn?.setAttribute('disabled', 'true');
        this.form.classList.add(this.errorClass);
      }
    }

    this.enter();
  }

  /**
   * アニメーション付きスクロール処理
   */
  enter() {
    if (!this.scroll) return;

    this.tccf7Create.createCursor(this.cursorId);
    this.elem.classList.add(this.animationClass);


    if(this.animation){
      this.editAnimation();
    }else {
      setTimeout(() => {
        const headerHeight = document.querySelector('.anchor-header') ? document.querySelector('.anchor-header')?.offsetHeight : 0;
        const targetTop = this.elem.getBoundingClientRect().top - headerHeight + window.scrollY;
        window.scrollTo({ top: targetTop });
      },0)
    }

    this.elem.classList.remove(this.animationClass);
    this.tccf7Create.remove(this.cursorId);
  }

  editAnimation() {
    const event = new CustomEvent('tccf7:scrollTo', { detail: { id: this.elemId } });
    document.dispatchEvent(event);
  }

  /**
   * 入力画面が存在しない場合のエラーログ
   */
  errInput() {
    if( this.inputWrap === null ) {
      console.log('%c☢　確認画面を表示したい場合は、入力画面となる要素を' + this.inputWrapId + 'wrapしてください[tccf7エラー]',this.error)
      return;
    }
  }

  /**
   * 確認画面が存在しない場合のエラーログ or 自動生成
   * @param {boolean} mode - 初回かどうか
   */
  errConfirm(mode) {
    if( this.confirmWrap === null ) {
      if( mode ){
        this.tccf7Create.createConfirm(this.confirmWrapId,this.inputWrap,this.form);
        this.confirmWrap = document.getElementById(this.confirmWrapId);
      }else{
        console.log('%c☢　確認画面となる要素を' + this.confirmWrapId + 'wrapしてください[tccf7エラー]',this.error);
        return;
      }
    }
  }
}
